import React, {useCallback} from 'react'
import styled from '@emotion/styled'

import {useDispatchTeamEvent} from '@vio/core/src/analytics/components/TeamContext'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'

export enum SelectedElementType {
  Rating = 'rating',
  Sentiment = 'sentiment',
  GuestTypesHeader = 'guestTypesHeader',
  GuestType = 'guestType',
  RatingElement = 'guestRating',
  ReadAllReviews = 'readAllReviews',
  ReviewCard = 'reviewCard',
  ReviewLogo = 'reviewLogo'
}

const Wrapper = styled.div<{hasHiddenOverflow?: boolean}>`
  overflow: ${({hasHiddenOverflow}) =>
    hasHiddenOverflow ? 'hidden' : 'visible'};
`

/**
 * Action wrapper to track specific element, reuse this if you need interaction as well
 */
const trackReviewClickEvent = (
  entity: Entity,
  selectedElement?: SelectedElementType
) =>
  trackEvent({
    category: Category.User,
    entity,
    action: Action.Clicked,
    ...(selectedElement ? {payload: {selectedElement}} : {})
  })

interface Props {
  dataId?: string
  element: SelectedElementType
  children: React.ReactNode
  entity: Entity
  stopPropagation?: boolean
  hasHiddenOverflow?: boolean
}

export const ReviewsTrackClick = ({
  dataId,
  element,
  children,
  entity,
  stopPropagation,
  hasHiddenOverflow = false
}: Props) => {
  const dispatchTeamEvent = useDispatchTeamEvent()
  const onClick: React.MouseEventHandler = useCallback(
    event => {
      if (stopPropagation) event.stopPropagation()
      dispatchTeamEvent(trackReviewClickEvent(entity, element))
    },
    [dispatchTeamEvent, element, stopPropagation]
  )

  return (
    <Wrapper
      data-id={dataId}
      onClick={onClick}
      role="presentation"
      hasHiddenOverflow={hasHiddenOverflow}
    >
      {children}
    </Wrapper>
  )
}
